import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import '../css/loginsignup.css';
import axios from 'axios';
import { UserContext } from '../UserContext';
import policyLockerImg from "../assets/policylockerimg.webp";
import TermsConditions from "../pages/TermsConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy";

const LoginSignup = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [isOtpLoginMode, setIsOtpLoginMode] = useState(true);
  const { user, setUser, setId, setToken, userRole, setRole, UserToken, setEmail, setMobile, setDateOfBirth, setGender } = useContext(UserContext);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [OTP, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [OtpMsg, setOtpMsg] = useState("");
  const [agreedToTerms, setAgreedToTerms] = useState(true);
  const [showShortPolicy, setShowShortPolicy] = useState(false);
  const [policyType, setPolicyType] = useState("");
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: ''
  });

  const API_URL = process.env.REACT_APP_Login_API_URL;
  const Dashboard_URL = process.env.REACT_APP_Dashboard_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from || "/home";



  useEffect(() => {
    if (user && UserToken && userRole) {
      if (userRole === "Admin" || userRole === "Partner" || userRole === "Employee") {
        window.location.href = `${Dashboard_URL}?token=${UserToken}`;
      } else {
        navigate(from, { replace: true });
      }
    }
  }, [user, UserToken, userRole, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === 'email') {
      validateEmail(value);
    }

    if (name === 'mobile') {
      validateMobile(value);
    }

    if (name === 'password') {
      validatePassword(value);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      setIsDisabled(true);
    } else {
      setEmailError('');
      setIsDisabled(false);
    }
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[6-9]\d{9}$/;
    if (mobile.length <= 10 && !mobileRegex.test(mobile)) {
      setMobileError('Please enter a valid Mobile number');
      setIsDisabled(true);
    } else {
      setMobileError('');
      setIsDisabled(false);
    }
  };

  const validatePassword = (password) => {
    const errors = [];
    if (password.includes(' ')) {
      errors.push('Password should not contain spaces');
    }
    if (password.length < 8) {
      errors.push('Password should be at least 8 characters long');
    }
    if (!/[A-Z]/.test(password)) {
      errors.push('Password should include at least 1 uppercase letter');
    }
    if (!/[a-z]/.test(password)) {
      errors.push('Password should include at least 1 lowercase letter');
    }
    if (!/[0-9]/.test(password)) {
      errors.push('Password should include at least 1 number');
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      errors.push('Password should include at least 1 special character');
    }

    setPasswordError(errors.length > 0 ? errors[0] : '');
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsDisabled(true);

    const Username = formData.name;
    const Email = formData.email;
    const Mobile = formData.mobile;
    const Password = formData.password;
    const RoleName = "User";

    if (isLogin) {
      setEmailError(false);
      try {
        if (isOtpLoginMode) {
          // Logic for sending OTP for login
          const response = await axios.post(`${API_URL}SendOtp`, { Email });
          if (response.status === 200) {
            setOtpMsg("OTP successfully sent to your mail. Please Check");
            setShowOtpPopup(true);
            setTimeout(() => {
              setOtpMsg("");
            }, 2000);

          } else {
            setLoginError(response.data?.errors || "Failed to send OTP.");
          }
        } else {
          const response = await axios.post(`${API_URL}Login`, {
            Email,
            Password,
          });
          if (response.status === 200) {
            const Token = (response.data.loginToken);
            const user = (response.data.user);
            const Id = (response.data.id);
            const userRole = (response.data.userRole);
            const Email = (response.data.email);
            const DateOfBirth = (response.data.dateOfBirth);
            const Gender = (response.data.gender);
            const Mobile = (response.data.mobile);
            setToken(Token);
            setId(Id);
            setUser(user);
            setRole(userRole);
            setEmail(Email);
            setDateOfBirth(DateOfBirth);
            setGender(Gender);
            setMobile(Mobile);
          } else {
            setLoginSuccess(false);
            setLoginError(true);
            setIsDisabled(true);
            setTimeout(() => {
              setLoginError(false);
            }, 5000);
          }
        }
      } catch (error) {
        setLoginSuccess(false);
        setLoginError(error.response?.data?.errors);
        setTimeout(() => {
          setLoginError("");
          setIsDisabled(false);
        }, 5000);
      }
    } else {
      if (emailError) {
        setFormSubmitted(false);
        setIsDisabled(true);
        return;
      }
      if (mobileError) {
        setErrorMessage('Please fix the mobile number errors before submitting');
        setIsDisabled(true);
        setFormSubmitted(false);
        return;
      }

      if (formData.password !== formData.confirmPassword) {
        setErrorMessage(
          <span style={{ textAlign: 'center', display: 'block' }}>
            Password and Confirm Password do not match
          </span>
        );
        setIsDisabled(false);
        setFormSubmitted(false);
        return;
      }

      if (passwordError) {
        setErrorMessage('Please fix the password errors before submitting');
        setIsDisabled(false);
        setFormSubmitted(false);
        return;
      }
      try {
        const response = await axios.post(`${API_URL}signup`, {
          Username,
          Password,
          Email,
          Mobile,
          RoleName,
        });
        if (response.status === 200) {
          if (response.data.user === false) {
            setShowOtpPopup(true);
          }
          setErrorMessage('');
          setOtpMsg(response.data.errors);
          setTimeout(() => {
            setOtpMsg('');
          }, 2000);
        }
      } catch (error) {
        setErrorMessage(error.response?.data?.errors);
        setTimeout(() => {
          setErrorMessage('');
        }, 5000);
        setIsDisabled(false);
      }
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const Email = formData.email;
      const response = await axios.post(`${API_URL}verify-otp`, {
        Email,
        OTP
      });
      if (response.status === 200) {
        setMessage(response.data.message);
        const Token = (response.data.loginToken);
        const user = (response.data.user);
        const Id = (response.data.id);
        const userRole = (response.data.userRole);
        const Email = (response.data.email);
        const DateOfBirth = (response.data.dateOfBirth);
        const Gender = (response.data.gender);
        const Mobile = (response.data.mobile);
        setToken(Token);
        setId(Id);
        setUser(user);
        setRole(userRole);
        setEmail(Email);
        setDateOfBirth(DateOfBirth);
        setGender(Gender);
        setMobile(Mobile);
        navigate(from, { replace: true });

        setTimeout(() => {
          setShowOtpPopup(false);
        }, 2000);
      } else {
        setTimeout(() => {
          setMessage(response.data.message || "Invalid OTP");
        }, 2000);
      }
    } catch (error) {
      setTimeout(() => {
        setMessage(error.response?.data?.error);
      }, 2000);
    }
  };

  const handleResendOtp = async (e) => {
    e.preventDefault();
    const Email = formData.email;
    try {
      const response = await axios.post(`${API_URL}SendOtp`, { Email }); // Assuming an API endpoint for sending OTP for login
      if (response.status === 200) {
        setOtpMsg("OTP successfully sent to your mail. Please Check");
        setShowOtpPopup(true);
        setTimeout(() => {
          setOtpMsg("");
        }, 2000);

      } else {
        setLoginError(response.data?.errors || "Failed to send OTP.");
      }
    } catch (error) {

    }
  };

  return (
    <div
      className="loginsignup-container"
      style={{
        position: 'relative',
        backgroundImage: from === "/policy-locker"
          ? `linear-gradient(rgba(0, 14, 41, 0.8), rgba(245, 165, 38, 0.6)), url(${policyLockerImg})`
          : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: from === "/policy-locker" ? 'cover' : 'auto',
        backgroundColor: from === "/policy-locker" ? '#000E29' : '#F0F8FF',
      }}
    >
      {from === "/policy-locker" && (
        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(11, 19, 43, 0.5)',
          pointerEvents: 'none',
          zIndex: 0,
        }} />
      )}

      <div className="loginsignup-box">
        <h2>
          {isLogin ? (isOtpLoginMode ? 'Login with OTP' : 'Login with Password') : 'Sign Up'}
        </h2>

        <form onSubmit={handleSubmit}>
          {isLogin ? (
            <>
              <div className="input-wrapper-row">
                <i className="fas fa-envelope icon-colored email-icon"></i>
                <input
                  type="email"
                  placeholder="enter your email"
                  className="loginsignup-input"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              {!isOtpLoginMode && (
                <>
                  <div className="input-wrapper-row last-login-input">
                    <i className="fas fa-lock icon-colored lock-icon"></i>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="enter your password"
                      className="loginsignup-input"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <i
                      className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} eye-icon`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></i>
                  </div>
                  <p className="forgot-password">
                    <Link to="/forgotpassword" style={{ color: '#FFF', textDecoration: 'none' }}>
                      Forgot Password?
                    </Link>
                  </p>
                </>
              )}

              <div className="policy-checkbox-wrapper">
                <input
                  type="checkbox"
                  id="policyAgree"
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                />
                <label htmlFor="policyAgree">
                  I agree to the <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPolicyType("terms"); setShowShortPolicy(true); }}>Terms & Conditions</span> and <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPolicyType("privacy"); setShowShortPolicy(true); }}>Privacy Policy</span>
                </label>
              </div>

              <button className="loginsignup-button" type="submit" disabled={isDisabled || !agreedToTerms}>
                {isOtpLoginMode ? 'Send OTP' : 'Login'}
              </button>

              <p className="loginsignup-toggle" style={{ marginTop: '25px', color: '#fff', fontSize: '14px', textAlign: 'center' }}>
                {isOtpLoginMode ? (
                  <span>
                    Prefer to login with <span
                      onClick={() => setIsOtpLoginMode(false)}
                      style={{ cursor: 'pointer', color: '#F5A526', fontWeight: 'bold' }}
                    >
                      Password?
                    </span>
                  </span>
                ) : (
                  <span>
                    Prefer to login with <span
                      onClick={() => setIsOtpLoginMode(true)}
                      style={{ cursor: 'pointer', color: '#F5A526', fontWeight: 'bold' }}
                    >
                      OTP?
                    </span>
                  </span>
                )}
              </p>

              <p className="loginsignup-toggle" style={{ marginTop: '15px' }}>
                Don’t have an account? <span onClick={() => setIsLogin(false)}>Sign Up</span>
              </p>

              {loginError && (
                <p style={{ color: loginError.includes("OTP sent to your email. Please verify.") ? "#4caf50" : "#f44336", marginTop: "16px", marginLeft: "20px" }}>
                  {loginError}
                </p>
              )}
            </>

          ) : (
            <>
              <div className="input-wrapper-row">
                <i className="fas fa-user icon-colored user-icon"></i>
                <input
                  type="text"
                  id="name"
                  placeholder="enter your name"
                  className="loginsignup-input"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="input-wrapper-row">
                <i className="fas fa-envelope icon-colored email-icon"></i>
                <input
                  type="email"
                  placeholder="enter your email"
                  className="loginsignup-input"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              {emailError && (
                <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{emailError}</div>
              )}

              <div className="input-wrapper-row">
                <i className="fas fa-phone icon-colored phone-icon p-1.5"></i>
                <input
                  type="tel"
                  placeholder=" enter your mobile number"
                  className="loginsignup-input"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  maxLength="10"
                />
              </div>
              {mobileError && (
                <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{mobileError}</div>
              )}

              <div className="input-wrapper-row">
                <i className="fas fa-lock icon-colored lock-icon"></i>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder=" create your password"
                  className="loginsignup-input"
                />
                <i
                  className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} eye-icon`}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
              {passwordError && (
                <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{passwordError}</div>
              )}

              <div className="input-wrapper-row">
                <i className="fas fa-lock icon-colored lock-icon"></i>
                <input
                  type={showConfirm ? 'text' : 'Password'}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="confirm password"
                  className="loginsignup-input"
                />
                <i
                  className={`fas ${showConfirm ? 'fa-eye-slash' : 'fa-eye'} eye-icon`}
                  onClick={() => setShowConfirm(!showConfirm)}
                ></i>
              </div>

              <div className="policy-checkbox-wrapper">
                <input
                  type="checkbox"
                  id="policyAgreeSignup"
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                />
                <label htmlFor="policyAgreeSignup">
                  I agree to the <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPolicyType("terms"); setShowShortPolicy(true); }}>Terms & Conditions</span> and <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPolicyType("privacy"); setShowShortPolicy(true); }}>Privacy Policy</span>
                </label>
              </div>

              <button
                className="loginsignup-button"
                type="submit"
                disabled={isDisabled || !agreedToTerms}
              >
                Register
              </button>

              <p className="loginsignup-toggle">
                Already have an account? <span onClick={() => setIsLogin(true)}>Login</span>
              </p>

              {formSubmitted && (
                <div style={{ color: "green", fontSize: "14px", marginTop: "5px" }}>
                  {formSubmitted}
                </div>
              )}

              {errorMessage && (
                <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{errorMessage}</div>
              )}
            </>

          )}
        </form>
        {/* 🔐 OTP POPUP */}
        {showOtpPopup && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}>
            <div style={{
              background: "#0b132b",
              borderRadius: "16px",
              padding: "30px 25px",
              width: "90%",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
              color: "#fff",
              position: "relative"
            }}>
              <button
                onClick={() => setShowOtpPopup(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  background: "transparent",
                  border: "none",
                  fontSize: "26px",
                  color: "#fff",
                  cursor: "pointer"
                }}
              >
                ×
              </button>
              <h2 style={{ marginBottom: "20px", fontSize: "22px" }}>Enter OTP</h2>
              <input
                type="text"
                maxLength={6}
                value={OTP}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter 6-digit OTP"
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: "6px",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  marginBottom: "20px",
                  color: "#000"
                }}
              />
              <button
                onClick={handleVerifyOtp}
                style={{
                  width: "80%",
                  padding: "10px",
                  background: "#f5a526",
                  border: "none",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "14px",
                  borderRadius: "25px",
                  cursor: "pointer",
                  marginTop: "10px"
                }}

              >
                Verify OTP
              </button>
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <span
                  onClick={handleResendOtp}
                  style={{
                    color: "#4CAF50",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer"
                  }}
                >
                  Resend OTP
                </span>
              </div>

              {message && (
                <p style={{
                  color: message.includes("OTP Verified Successfully !") ? "#4caf50" : "#f44336",
                  marginTop: "16px"
                }}>
                  {message}
                </p>
              )}
              {OtpMsg && <div className="hero-bottom-popup-success">{OtpMsg}</div>}
            </div>
          </div>
        )}
      </div>

      {showShortPolicy && (
        <div className="policy-popup-overlay">
          <div className="policy-popup-box large-policy-popup">
            <button
              className="policy-top-close"
              onClick={() => setShowShortPolicy(false)}
            >
              &times;
            </button>

            <h3 className="policy-title">
              {policyType === "terms" ? "Terms & Conditions" : "Privacy Policy"}
            </h3>

            <div className="policy-content-scroll">
              {policyType === "terms" ? (
                <TermsConditions />
              ) : (
                <PrivacyPolicy />
              )}
            </div>

            <div className="policy-popup-footer">
              <span className="policy-agree-text">
                I agree with this{" "}
                {policyType === "terms"
                  ? "Terms & Conditions"
                  : "Privacy Policy"}
              </span>

              <button
                className="policy-accept-btn"
                onClick={() => {
                  setAgreedToTerms(true);
                  setShowShortPolicy(false);
                }}
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginSignup;